import { useRef } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { RouteProvider } from "views/components/Provider";
import { fetchHourBlocks } from "network/requests";
import { getUserTicket, selectUserTicketByLine } from "state/tickets/selectors";
import {
	isDniRequired as isDniRequiredFn,
	isRutRequired as isRutRequiredFn,
} from "lib/helpers/documents";
import { isUserPhoneValid, isUserSsnValid } from "state/users/selectors";
import { pathOr } from "ramda";
import { pushNotificacionSubscription } from "lib/subscribeToPushNotifications";
import { selectLine } from "state/lines/selectors";
import { useAuth } from "hooks/useAuth";
import { useGetForms } from "hooks/useGetForms";
import { useGetOfficeRestrictions } from "hooks/useGetOfficeRestrictions";
import { useOffice } from "state/offices/hooks";
import { useQuery } from "hooks/useQuery";
import { Loader } from "./Loader";
import ReCAPTCHA from "react-google-recaptcha";

import React, {
	setGlobal,
	useDispatch,
	useEffect,
	useGlobal,
	useState,
} from "reactn";
import { useTemporaryUser } from "hooks/useTemporaryUser";
import { useRecaptcha } from "hooks/useRecaptcha";
import config from "config";
import { getSessionId } from "lib/sessionIdTemporaryUser";
// this function is too big
// fix by separating in multiple providers:
//  - ticketProvider
//  - reservationProvider
//  - modal provider
const LineDetail = ({ match, history, children }) => {
	const query = useQuery();
	const { isLoggedInTemporary, isLoggedIn } = useAuth();
	const officeSlug = match.params.officeslug;
	const lineSlug = match.params.lineslug;
	const doLoginAsGuest = useDispatch("doLoginAsGuest");
	const [showModalTemporary, setShowModalTemporary] = useState(false);
	const [tickets] = useGlobal("tickets");
	const [ticketsv2] = useGlobal("ticketsv2");
	const logOut = useDispatch("logout");
	const [lines] = useGlobal("linesv2");
	const [user] = useGlobal("user");
	const [newTicket] = useGlobal("newTicket");
	const [customerParams] = useGlobal("customerParams");
	const loggedIn = Boolean(user && user.token);
	const [modalState, setModalState] = useState("closed");
	const [loginModalState, setLoginModalState] = useState("");
	const [registerModalState, setRegisterModalState] = useState("");
	const [isLoading, setLoading] = useState(false);
	const temporary = query.get("temporary");
	const autoTicketAction = query.get("autoTicketAction");
	const [modalWithoutLoginState, setModalWithoutLoginState] =
		useState("closed");
	const [modalWithoutLoginRutState, setModalWithoutLoginRutState] =
		useState("closed");
	const [isVisibleConfirmationModal, setIsVisibleConfirmationModal] =
		useState(false);
	const [enabledReservations, setEnabledReservations] = useState(false);

	const [office, officeLoading] = useOffice(officeSlug);
	const { restrictions } = useGetOfficeRestrictions({ office });
	const line = selectLine(lines, lineSlug.trim());
	const userTicketId = getUserTicket(ticketsv2, lineSlug);
	const currentTicket = selectUserTicketByLine(ticketsv2, lineSlug);
	const webOnly = pathOr(false, ["options", "web_only"], office);
	const pickTicketSaga = useDispatch("pickTicketSaga");
	const pickTicketSagaWebOnly = useDispatch("pickTicketSagaWebOnly");
	const getTickets = useDispatch("fetchUserTickets");
	
	const sagaRestarted = useDispatch("sagaRestarted");
	// const getTimeBlocks = useDispatch("getTimeBlocks");
	const [userId, setUserId] = useState("");
	
	//KM
	const isPickQuickTicketActive = pathOr(false, ["options", "pickQuickTicketIsActive"], office);
	const [inputs, setInputs] = useState({});
	const refCaptcha = useRef();
	const { recaptchaKey } = config;
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const isQuickTicket = searchParams.get("quick-ticket") || isPickQuickTicketActive;
	const [login] = useTemporaryUser(closeTicketWihtoutLogin);
	const { onSubmitWithReCAPTCHA, loading: reCaptchaLoading } = useRecaptcha(
		login,
		refCaptcha
	);

	const showInputRutInModalWihtoutLogin =
		modalWithoutLoginRutState === "show";

	const isVisibleModalWithoutLogin =
		loginModalState === "closed" && modalWithoutLoginState === "open";

	//const todayTimeblocks = selectTimeblocks(timeblocks, lineSlug, new Date());
	const todayTimeblocks = [];
	const v2 = pathOr(false, ["options", "reservations_v2"], office);
	const hasDni = user && user.dni && user.dni.length > 0 ? true : false;
	const hasRut = user && user.rut && user.rut.length > 0 ? true : false;
	const allowsWhatsapp = pathOr(false, ["notifications", "whatsapp"], user);

	const isActivePushNotifications = pathOr(
		false,
		["notifications", "push"],
		user
	);

	const askForSsn =
		!isUserSsnValid(user) && pathOr(false, ["options", "mode_rut"], office);

	const askForSsnWithoutLogin = pathOr(
		false,
		["options", "mode_rut"],
		office
	);

	const modeRut = pathOr(false, ["options", "mode_rut"], office);
	const modeDni = pathOr(false, ["options", "dni_peru"], office);
	const areTicketFormsActive = pathOr(
		false,
		["options", "areTicketFormsActive"],
		office
	);
	const virtualRoom = pathOr(false, ["options", "virtualRoom"], office);

	const ticketMeet = virtualRoom ? true : false;
	const closeLoginModal = () => {
		setLoginModalState("closed");
	};
	const isDniRequired = isDniRequiredFn({
		hasDni,
		isLoggedIn,
		isLoggedInTemporary,
		modeDni,
		modeRut,
	});

	const isRutRequired = isRutRequiredFn({
		hasRut,
		isLoggedIn,
		isLoggedInTemporary,
		modeRut,
		modeDni,
	});
	const {
		forms: ticketFormsData,
		loading: areTicketFormsLoading,
		error,
	} = useGetForms({
		officeId: office && office.id,
		lineId: line && line.id,
		isTicket: true,
		areFormsNeeded: areTicketFormsActive,
	});

	const ticketForms = pathOr([], ["questions"], ticketFormsData);

	const askForPhone =
		!isUserPhoneValid(user) &&
		pathOr(false, ["options", "notifications", "whatsapp"], office) &&
		(allowsWhatsapp === true || allowsWhatsapp === "prompt");

	const handleOnCheckOfficesV1 = async (id) => {
		try {
			const blocks = await fetchHourBlocks(id);
			setEnabledReservations(blocks?.length > 0 ?? false);
		} catch (error) {}
	};

	/** this is a hack for testing purposes */
	// Note: there is a race condition where this
	// doesn't work if user data is loaded after this is run
	const userUpdated = useDispatch("userUpdated");
	useEffect(() => {
		///http://localhost:3000/offices/zero-q-demo/lines/zero-q-demo-atencion-de-urgencia
		if (lineSlug.trim() === "zero-q-demo-primera-licencia-ampliacion") {
			userUpdated({ data: { phone: "" } });
		}
	}, [userUpdated, lineSlug]);
	/** end of hack */

	const pickTicket = () => {
		if (
			modalState !== "open" &&
			askForSsn &&
			!showInputRutInModalWihtoutLogin
		) {
			closeLoginModal();
			setModalState("open");
			return;
		}

		closeLoginModal();
		if (webOnly) {
			closeTicketWihtoutLogin();

			const utmToSend = Object.values(customerParams).length
				? Object.values(customerParams).join("-")
				: null;

			const meta = {
				formsError: error ? "request has failed" : null,
			};

			pickTicketSagaWebOnly({
				officeSlug,
				lineSlug,
				_lineId: line && line.id,
				officeId: office.id,
				meet: ticketMeet,
				meta: utmToSend ? { ...meta, utm: utmToSend } : meta,
			});
			return;
		}
		pickTicketSaga({
			officeSlug,
			lineSlug,
			_lineId: line && line.id,
			officeId: office.id,
		});
	};

	const navigateToTicketScreen = () => {
		if (virtualRoom) {
			return history.push(
				`/waiting-room/${officeSlug}/${lineSlug}/${currentTicket.tuid}`
			);
		}

		return history.push(
			`/ticket/${officeSlug}/${lineSlug}/${currentTicket.tuid}`
		);
	};

	// const navigateToLogin = () => {
	// 	history.push("/welcome", { from: history.location.pathname });
	// };

	const navigateToReservationScreen = () => {
		if (temporary) {
			return history.push(
				`/offices/${officeSlug}/${lineSlug}/reservation?temporary=true`,
				{
					from: history.location.pathname,
				}
			);
		}
		history.push(`/offices/${officeSlug}/${lineSlug}/reservation`, {
			from: history.location.pathname,
		});
	};

	useEffect(() => {
		// const asyncF = async () => {
		// 	setLoading(true);
		// 	// TODO: prevent this from re-fetchin
		// 	await getTickets();
		// 	setLoading(false);
		// };
		if (!isLoggedInTemporary) {
			if (isLoggedIn) {
				setLoading(true);
				// // TODO: prevent this from re-fetchin

				getTickets()
					.then(() => setLoading(false))
					.catch(() => setLoading(false));
			}
			return;
		}
		// asyncF();
	}, [officeSlug, getTickets]);

	useEffect(() => {
		if (temporary) {
			// console.log("temporary");
			logOut();
		}
	}, [temporary]);

	// useEffect(() => () => sagaRestarted(), []);

	/*
	useEffect(() => {
		if (office && v2)
			getTimeBlocks({ lineSlug, officeSlug, date: new Date() });
	}, [lineSlug, office, getTimeBlocks]);
	*/

	//KM
	useEffect(() => {
		getSessionId(officeSlug).then((res) => {
			const string = res.toString();
			setInputs((i) => ({ ...i, ["sessionId"]: string }));
		});
	}, []);
	const handleClick = () => {
		onSubmitWithReCAPTCHA(inputs, null, pickTicket).then((token) => {
			closeTicketWihtoutLogin();
		});
	};

	const ticketAction = () => {
		//KM
		const fn = isQuickTicket ? handleClick : handlerWithoutLoginModal;
		if (autoTicketAction) {
			if (temporary || isQuickTicket) {
				return fn();
			}
			if (areTicketFormsActive && ticketForms.length > 0) {
				return history.push(`/ticket-forms/${officeSlug}/${lineSlug}`);
			}

			pickTicket();
			return;
		}

		if (!userTicketId) {
			if (user.guest) {
				if (temporary || isQuickTicket) {
					closeLoginModal();
					return fn();
				}
				isActiveLoginModal();
			} else {
				closeLoginModal();

				if (isRutRequired || isDniRequired) {
					return fn();
				}

				if (areTicketFormsActive && ticketForms.length > 0) {
					return history.push(
						`/ticket-forms/${officeSlug}/${lineSlug}`
					);
				}

				pickTicket();
			}
		} else {
			navigateToTicketScreen();
		}
	};

	useEffect(() => {
		if (!areTicketFormsLoading && autoTicketAction && office && lines) {
			ticketAction();
		}
	}, [areTicketFormsLoading, office, lines]);

	useEffect(() => {
		setUserId(JSON.stringify(user.user_id));
	}, [user]);

	useEffect(() => {
		if (isActivePushNotifications && userId) {
			pushNotificacionSubscription(userId);
		}
	}, [userId]);
	//This fix guest state on desktop
	useEffect(() => {
		if (!loggedIn) {
			doLoginAsGuest();
		}
	}, [doLoginAsGuest, loggedIn]);

	useEffect(() => {
		const { options, id } = office ?? {};

		if (!options?.reservations_v2 && id) {
			handleOnCheckOfficesV1(id);
		} else {
			setEnabledReservations(options?.reservations_v2 ?? false);
		}
	}, [office]);

	if (newTicket.didFinish === true) {
		return (
			<Redirect
				to={`/${
					virtualRoom ? "waiting-room" : "ticket"
				}/${officeSlug}/${lineSlug}/${newTicket.ticket.tuid}`}
			/>
		);
	}

	if (isLoading || officeLoading || !line || !office || areTicketFormsLoading)
		return <Loader />;

	const ticketDisabled =
		(line.meta && line.meta.disabled_virtual_tickets) ||
		line.frozen ||
		areTicketFormsLoading;

	const isTicketDisabledByOffice = office && !office.online;

	const ticketLabel = (() => {
		if (ticketDisabled) return "Fila deshabilitada";
		if (user.guest) return "Sacar ticket";
		if (!userTicketId) return "Sacar ticket";
		return "Ver ticket";
	})();

	const attention_type = pathOr(
		"presencial",
		["options", "reservations", "attention_type"],
		office
	);

	// todo: add reservations disabled
	const reservationDisabled =
		line && line.meta && line.meta.disabled_reserves;

	const modalVisible =
		(modalState === "open" && (askForSsn || askForPhone)) ||
		modalState === "force";
	const closeModal = () => setModalState("closed");

	const goBack = () =>
		temporary
			? history.push(`/offices/${officeSlug}?temporary=true`)
			: history.push(`/offices/${officeSlug}`);
	//LoginModal
	const loginModalIsVisible = loginModalState === "open";

	const isActiveLoginModal = () => {
		if (user.guest) {
			setLoginModalState("open");
		} else {
			ticketAction();
		}
	};

	//RegisterModal

	const signUpModalIsVisible = registerModalState === "open";

	const activeSignUpModalInTemporaryUser = () => {
		setRegisterModalState("open");
	};
	const isActiveRegistryModal = () => {
		if (loginModalState === "open") {
			setLoginModalState("closed");
			setRegisterModalState("open");
		} else {
			ticketAction();
		}
	};
	const closeSignUpModal = () => setRegisterModalState("closed");

	//ticket without login modal

	const handlerWithoutLoginModal = () => {
		closeSignUpModal();
		closeLoginModal();

		if (askForSsnWithoutLogin) {
			setModalWithoutLoginRutState("show");
			setModalWithoutLoginState("open");
		} else {
			setModalWithoutLoginState("open");
		}
	};

	const closeTicketWihtoutLogin = () => {
		setModalWithoutLoginState("closed");
	};

	return (
		<>
			{isQuickTicket && (
				<ReCAPTCHA
					hl={"es-419"}
					ref={refCaptcha}
					sitekey={recaptchaKey}
					size={"invisible"}
				/>
			)}

			{children({
				areTicketFormsLoading,
				activeSignUpModalInTemporaryUser,
				askForPhone,
				askForSsn,
				attention_type,
				closeLoginModal,
				closeModal,
				closeSignUpModal,
				closeTicketWihtoutLogin,
				currentTicket,
				enabledReservations,
				goBack,
				handlerWithoutLoginModal,
				isActiveLoginModal,
				isActiveRegistryModal,
				isDniRequired,
				isRutRequired,
				isTicketDisabledByOffice,
				isVisibleConfirmationModal,
				isVisibleModalWithoutLogin,
				line,
				loginModalIsVisible,
				modalVisible,
				navigateToReservationScreen,
				navigateToTicketScreen,
				newTicket,
				office,
				pickTicket,
				reservationDisabled,
				restrictions,
				setIsVisibleConfirmationModal,
				setModalState,
				setShowModalTemporary,
				showInputRutInModalWihtoutLogin,
				showModalTemporary,
				signUpModalIsVisible,
				ticketAction,
				ticketDisabled,
				ticketLabel,
				todayTimeblocks,
				user,
				v2,
				webOnly,
				ticketFormsData,
			})}
		</>
	);
};

export default RouteProvider(LineDetail);
